import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";



const affiliateService = {
  getSettings:() => ApiClient.get(`settings/referral-settings`),
  getSettingById:(id:string) => ApiClient.get(`settings/referral-settings/${id}`),
  createSettings:(data:any) => ApiClient.post(`settings/referral-settings`, data),
  editSettings:(data:any, id:string) => ApiClient.put(`settings/referral-settings/${id}`, data),
  deleteSettings:(id:string) => ApiClient.delete(`settings/referral-settings/${id}`),
}

export default affiliateService